import type { BulkOperationsViewProps } from "@/domains/diagnostics/types"
import { Button } from "@/components/button"
import { Card } from "@/components/card"

export const BulkOperationsView = ({
  onStartAll,
  onStopAll,
  onForceExecuteAll,
  onDisposeAll,
}: BulkOperationsViewProps) => {
  return (
    <Card.Container>
      <h3 className="mb-4 text-lg font-semibold text-t100">Bulk Operations</h3>
      <div className="flex flex-wrap gap-2">
        <Button variant="primary" onClick={onStartAll}>
          Start All Queries
        </Button>
        <Button variant="neutral" onClick={onStopAll}>
          Stop All Queries
        </Button>
        <Button variant="primary" onClick={onForceExecuteAll}>
          Force Execute All
        </Button>
        <Button variant="error" onClick={onDisposeAll}>
          Dispose All Queries
        </Button>
      </div>
    </Card.Container>
  )
}
